import Route from '@ember/routing/route';
import { service } from '@ember/service';
import CacheService from 'donor-elf-web/services/cache-service';
import NavbarSettingsService from 'donor-elf-web/services/navbar-settings';

export interface LoginRouteModel {
  email: string;
  password: string;
  hasLoginToken: boolean;
}

export default class LoginRoute extends Route {
  @service declare cacheService: CacheService;
  @service declare navbarSettings: NavbarSettingsService;
  @service declare session: any;

  async model(): Promise<LoginRouteModel> {
    this.navbarSettings.title = 'Login';
    let appParams = this.paramsFor('application') as any;

    await this.cacheService.unloadAll();
    if (this.session.isAuthenticated) {
      await this.session.invalidate();
    }

    let model = {
      email: appParams.loginEmail || '',
      password: '',
      hasLoginToken: false,
    } as LoginRouteModel;

    return model;
  }
}
